import { Separator, VStack } from '@chakra-ui/react';
import { PolygonCoordinatesInput } from '@components/common/inputs/PolygonCoordinatesInput';
import { FormMap } from '@components/ui/map/formMap/FormMap';
import { useFormikContext } from 'formik';

import { Platform } from '@/types/config/config.types';

export function PlatformFormMap() {
  const { values } = useFormikContext<Partial<Platform>>();

  return (
    <FormMap polygon={values.polygon} mode={values.id ? 'edit' : 'create'}>
      <VStack
        position="absolute"
        borderRight="2px solid"
        borderColor="neutral.black"
        backgroundColor="neutral.700"
        left={0}
        height="100%"
        flexShrink={0}
        zIndex={3}
        gap={0.25}
        separator={<Separator size="md" borderColor="neutral.800" marginY={0} />}
      >
        <PolygonCoordinatesInput />
      </VStack>
    </FormMap>
  );
}
